import React from 'react';

import { Box } from '../../../Box';

export const Divider = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box width="1px" height="16px" bgcolor="stroke.secondary" mx="8" />
    </Box>
  );
};
